import { useState, useEffect, useRef } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import moment from "moment";
import { useDispatch } from "react-redux";
import {
  createTrip,
  fetchCitys,
  fetchHotels,
  updateTrip
} from "../../../../store/reducers/home/apiThunk";
import { ToastNotifyError } from "../../../CommonComponents/Toast/ToastNotify";
import { updateLoading } from "../../../../store/reducers/loader";
import { useShoppingCart } from "../../../../context/ShoppingCartContext";

export function useSearchbox(setShowCreateTrip = () =>{}, getTripDetails =()=>{}, { isModal = true } = {}) {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(null);
  const [cityValue, setCityValue] = useState(null);
  const [optionsHotels, setOptionsHotels] = useState([]);
  const [optionsCitys, setOptionsCitys] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const dispatch = useDispatch();
  const theme = useTheme();
  const isSmOrLarger = useMediaQuery(theme.breakpoints.up("lg"));
  const minSelectableDate = moment().add(1, "day");
  const  {isFormOpen, onClose, setIsFormOpen, isOpen, selectedProduct }= useShoppingCart();
  const changedBy = useRef(null);
  const reset = () => {
    setValue(null);
    setSelectedDate(null);
    setCityValue(null);
  }
  const onSubmit = async (tripId) => {
    if(!value?.id && !cityValue?.id && !selectedDate) return;
    dispatch(updateLoading(true));
    const guestUserSessionKey = localStorage.getItem("guestUserSessionKey");
        let tripPayload;
        if(guestUserSessionKey) {
          tripPayload = {
            hotel: value ? value?.id : null,
              city: cityValue ? cityValue?.id : null,
              arrival_date: selectedDate
                ? moment(selectedDate).format("YYYY-MM-DD")
                : null,
            session_id: guestUserSessionKey,
          }
        } else {
            tripPayload = {
              hotel: value ? value?.id : null,
              city: cityValue ? cityValue?.id : null,
              arrival_date: selectedDate
                ? moment(selectedDate).format("YYYY-MM-DD")
                : null,
            };
        }
    const updateTripData = {tripPayload:tripPayload, tripId:tripId}
    try {
      const response = tripId ? await dispatch(updateTrip(updateTripData)) :  await dispatch(createTrip(tripPayload));
  
      if (response?.payload?.status || response?.type === "home/update/fulfilled") {
        if (isFormOpen) {
          reset()
          setShowCreateTrip(false);
          if(selectedProduct ===null)
          onClose()
          setIsFormOpen(false)
        } else {
          reset()
          setShowCreateTrip(false);
        }
        if(getTripDetails)
        getTripDetails()
      }
    } catch (err) {
      console.error("Error creating trip:", err);
    } finally {
      dispatch(updateLoading(false));
    }
  };

  const searchHotels = async (cityId) => {
    try {
      const response = await dispatch(fetchHotels(cityId || undefined));
      const { status, data, message } = response.payload;
      if (status) {
        setOptionsHotels(data);
      } else {
        ToastNotifyError(message);
      }
    } catch (error) {
      console.error("Error fetching hotels:", error);
    }
  };

  const searchCity = async (hotelId) => {
    try {
      const response = await dispatch(fetchCitys(hotelId || undefined));
      const { status, data, message } = response.payload;
      if (status) {
        setOptionsCitys(data);
        return data;
      } else {
        ToastNotifyError(message);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
    return [];
  };

  const getHotelCity = async (hotelId) => {
    try {
      const response = await dispatch(fetchCitys(hotelId));
      const { status, data, message } = response.payload;
      if (status) {
        return data;
      } else {
        ToastNotifyError(message);
      }
    } catch (error) {
      console.error("Error fetching hotel city:", error);
    }
    return [];
  };

  useEffect(() => {
    searchHotels();
    searchCity();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  useEffect(() => {
    if (changedBy.current === "hotel") {
      changedBy.current = null;
      return;
    }
    if (changedBy.current === "trip") return;
    changedBy.current = "city";
    setValue(null);
    searchHotels(cityValue?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cityValue]);

  useEffect(() => {
    if (changedBy.current === "city") {
      changedBy.current = null;
      return;
    }
    if (changedBy.current === "trip") {
      changedBy.current = null;
      return;
    }
    if (value?.id) {
      changedBy.current = "hotel";
      // Get specific city for this hotel (this doesn't replace optionsCitys)
      getHotelCity(value.id).then((hotelCities) => {
        if (hotelCities?.length && optionsCitys?.length) {
          // Find the hotel's city in the existing cities list and set it
          const hotelCity = optionsCitys.find(city => city.id === hotelCities[0].id);
          if (hotelCity) {
            setCityValue(hotelCity);
          }
        }
      });
    }
    // Removed the else block that was clearing city when hotel is cleared
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  useEffect(() => {
    if (isModal) reset()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const setFromTripData = (tripData) => {
    changedBy.current = "trip";
    if (tripData?.city_name)
      setCityValue({ id: tripData.city, name: tripData.city_name });
    else setCityValue(null);
    if (tripData?.hotel_name)
      setValue({ id: tripData.hotel, name: tripData.hotel_name });
    else setValue(null);
    if (tripData?.arrival_date)
      setSelectedDate(moment(tripData.arrival_date).valueOf());
    else setSelectedDate(null);
  };

  return {
    open,
    setOpen,
    value,
    setValue,
    cityValue,
    setCityValue,
    optionsHotels,
    optionsCitys,
    selectedDate,
    setSelectedDate,
    minSelectableDate,
    isSmOrLarger,
    onSubmit,
    reset,
    setFromTripData
  };
}
